import {Navigate, useLocation} from 'react-router-dom'
import {getItemFromStorage} from 'utils/storage'

const PublicRoute = ({children, isAuth}) => {
  const user = getItemFromStorage({name: 'user'})
  const location = useLocation()

  if (
    user?._id &&
    (location.pathname === '/login' ||
      location.pathname === '/register' ||
      location.pathname === '/forgot-password' ||
      location.pathname === '/login/phone' ||
      location.pathname === '/reset-password')
  ) {
    return <Navigate to="/dashboard" replace />
  }
  return children
}

export default PublicRoute
